module.exports = __webpack_public_path__ + "img/upload.cdac2e31.jpg";